export const familyLifeGtmTagId = 'GTM-WJDNWVM7';
export const aiaGtmTagId = 'GTM-KHJ69K5C';
